import HostMatcher from './-private/host-matcher';
import { warn } from '@ember/debug';

// Mappings of Square domains to API sub-domains.
//
// TODO: while most of the entries in this array are general to Square,
// consumers may want to configure or add to this array (evidenced by the
// presence of one Dashboard specific mapping here).
const HOST_MATCHERS = [new HostMatcher(/^(.+\.)*squareup.com$/, () => {
  return 'api.squareup.com';
}), new HostMatcher(/^(.+\.)*squareupsandbox.com$/, () => {
  return 'api.squareupsandbox.com';
}), new HostMatcher(/^(.+\.)*squareupstaging.com$/, () => {
  return 'api.squareupstaging.com';
}), new HostMatcher(/^(.+\.)*squareup.com.([^.]+\.local)$/, match => {
  return `api.squareup.com.${match[2]}`;
}), new HostMatcher(/^localhost:(\d+)$/, match => `localhost:${match[1]}`)];
/**
 * Determines the API sub-domain for a given domain.
 *
 * This function allows easily configuring an API call to be sent to
 * the API sub-domain. For example:
 *
 * - `api.squareup.com` instead of `squareup.com`
 *
 * @param {string} host
 * @returns {string} The API sub-domain
 */
export function apiHost(host, options) {
  if (options?.useSameHost) {
    return host;
  }
  for (const hostMatcher of HOST_MATCHERS) {
    const match = hostMatcher.match(host);
    if (match) {
      return match;
    }
  }
  warn(`cannot determine API host for host: ${host}`, false, {
    id: 'apiHost'
  });
  return host;
}